export default "__VITE_ASSET__mxv$4yB4__"